// Care dintre cei doi pași ai fundației e „fundația" pentru restul ecranelor.
//
// Geometria tălpii se stabilește în doi timpi, fiindcă ea și modelul se
// condiționează reciproc:
//
//   Pasul 6   PREDIMENSIONEAZĂ pe o greutate estimată empiric — e tot ce
//             există înainte să existe modelul, iar Pasul 7 se reazemă pe ea;
//   Pasul 17  o ADOPTĂ, după ce a verificat-o ax cu ax pe reacțiunile reale:
//             acolo B se poate lăți, cota coborî, iar axe întregi dispărea.
//
// Un ecran care citește predimensionarea după ce Pasul 17 a rulat descrie o
// fundație care nu mai există — de aceea nimeni nu mai scrie cheia direct.
// REGULA e a serverului (`depozit.pasul_fundatiei_adoptate`: Pasul 17 când e
// gata și nu e mai vechi decât Pasul 6, altfel Pasul 6) și vine în rezumatul
// pașilor ca `fundatie_adoptata` pe cele două rânduri; aici se citește doar.

import { StepState } from "./tipuri";

export const PAS_FUNDATIE_PREDIM = "rezistenta_fundatie";
export const PAS_FUNDATIE_ADOPTATA = "verificare_fundatie";

type Pasi = Record<string, StepState | undefined | null>;

/** Cheia pasului din care se citește fundația: cel pe care serverul l-a
 *  marcat `fundatie_adoptata`; Pasul 6 cât timp niciunul nu e marcat. E și
 *  pagina spre care trebuie să ducă linkurile — altfel omul ar ateriza pe
 *  cifre pe care nu le vede nicăieri în pagină. */
export function cheiaFundatiei(steps: Pasi): string {
  return steps[PAS_FUNDATIE_ADOPTATA]?.fundatie_adoptata
    ? PAS_FUNDATIE_ADOPTATA
    : PAS_FUNDATIE_PREDIM;
}

/** Starea pasului fundației adoptate, sau `null` când niciunul n-a rulat. */
export function pasulFundatiei(steps: Pasi): StepState | null {
  return steps[cheiaFundatiei(steps)] ?? null;
}

/** Rezultatul fundației adoptate; `null` dacă niciunul n-a rulat. */
export function fundatiaAdoptata(steps: Pasi): Record<string, unknown> | null {
  return (pasulFundatiei(steps)?.result ?? null) as Record<string, unknown> | null;
}
